import { useEffect } from 'react'
import { AlertsCard } from './AlertsToggle'
import { refreshAlerts } from './alertsStore'
import { openPwaSheet } from './events'

/**
 * Settings (header gear, Global): the same alerts switch as the More menu and the profile (Bez 2026-10-07: the More menu is easy to
 * miss). Reads the real state when Settings opens; a step that leaves Settings (the claim page, the install sheet) closes it first.
 */
export default function SettingsAlerts({ onDismiss }: { onDismiss?: () => void }) {
  useEffect(() => {
    refreshAlerts()
  }, [])
  return (
    <div data-testid="settings-alerts" style={{ marginBottom: 24 }}>
      <AlertsCard
        onInstall={() => {
          onDismiss?.()
          openPwaSheet('install')
        }}
        onNavigate={onDismiss}
      />
    </div>
  )
}
